import { MigrateAlertType } from './reducer';
export const unexpected = () => ({ type: MigrateAlertType.UNEXPECTED });
export const clear = () => ({ type: MigrateAlertType.CLEAR });
